import { render, staticRenderFns } from "./notifications-container.vue?vue&type=template&id=ea07fb38"
import script from "./notifications-container.vue?vue&type=script&lang=ts"
export * from "./notifications-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea07fb38')) {
      api.createRecord('ea07fb38', component.options)
    } else {
      api.reload('ea07fb38', component.options)
    }
    module.hot.accept("./notifications-container.vue?vue&type=template&id=ea07fb38", function () {
      api.rerender('ea07fb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/notifications/notifications-container.vue"
export default component.exports